import { Hidden }                   from "@material-ui/core";
import * as React                   from "react";
import { FC }                       from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card }                     from "semantic-ui-react";
import Account                      from "../../../../domain/account/Account";
import AccountRoleType              from "../../../../domain/account/AccountRoleType";
import { ResKaState }               from "../../../../index";
import RouterDispatcher             from "../../../../infrastructure/redux/router/RouterDispatcher";

const StaffAccountSettingButton: FC = () => {
  const account: Account = useSelector((state: ResKaState) => state.account);
  const routerDispatcher: RouterDispatcher = new RouterDispatcher(useDispatch());

  switch (account.role.value) {
    default:
      return null;
    case AccountRoleType.CORPORATION:
    case AccountRoleType.OFFICE:
      return (
        <>
          <Hidden smDown={ true }>
            <Card onClick={ () => routerDispatcher.staffs() }>
              <Card.Content>
                <Card.Header>スタッフアカウントを作成・削除する</Card.Header>
                <Card.Description>
                  ResKaを利用するスタッフ専用のアカウントを作成することができます。<br/>
                  スタッフアカウントは機能が制限されており、情報を安全に管理することができます。
                </Card.Description>
              </Card.Content>
            </Card>
          </Hidden>

          <Hidden mdUp={ true }>
            <Card onClick={ () => routerDispatcher.staffs() }>
              <Card.Content>
                <Card.Header>スタッフアカウントを作成・削除する</Card.Header>
              </Card.Content>
            </Card>
          </Hidden>
        </>
      );
  }
};

export default StaffAccountSettingButton;
